import { Link } from "react-router-dom";

function BlogList(props) {

    const blogs = props.blogs;

    return (
        <div>
            {
                blogs.map((blog) => (
                    <div>
                        <Link to={`/blogs/${blog.id}`}>
                            <h2>{blog.title}</h2>
                            <p>{blog.author}</p>
                            {/*<button onClick={() => handleDelete(blog.id)}>Delete Blog</button>*/}
                        </Link>
                    </div>
                ))
            }
        </div>
    );
}

export default BlogList;